

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../style/adminform.css"
import "../style/CustomPopup.css"
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import "reactjs-popup/dist/index.css";
import CustomPopup from "./CustomPopup";
import Autocomplete from "@mui/material/Autocomplete";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import AnimatedCircularProgressBar from "../registry/magicui/animated-circular-progress-bar";
import { TextField, MenuItem } from "@mui/material";
import { AbstractAPI } from "../api";

import { pdfjs } from "react-pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

function escapeRegExp(str = "") {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export default function AdminForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const initial = location.state?.initial || null;

    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [success, setSuccess] = useState(false);

    // state for single-file upload when user selects a file
    const [fileUploading, setFileUploading] = useState(false);

    const [form, setForm] = useState({
        Abstract_Id: "",
        Year: "",
        Status: "active",
        title: "",
        author: "",
        category: "",
        subcategory: "",
        abstract: "",
        summary: "",
        link: "",
    });


    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [years, setYears] = useState([]);

    const [newCategory, setNewCategory] = useState("");
    const [newSubcategory, setNewSubcategory] = useState("");
    const [newYear, setNewYear] = useState("");

    const [coAuthors, setCoAuthors] = useState([{ id: 1, name: "" }]);
    const [files, setFiles] = useState([]);
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [summaryFile, setSummaryFile] = useState(null);
    const [summaryUploading, setSummaryUploading] = useState(false);
    const [summaryProgress, setSummaryProgress] = useState(0);
    const [summaryError, setSummaryError] = useState(null);
    const [sizeErrorPopup, setSizeErrorPopup] = useState(false);
    const [submitErrorPopup, setSubmitErrorPopup] = useState(false);
    const [submitErrorMessage, setSubmitErrorMessage] = useState("");
    const [summaryFilePath, setSummaryFilePath] = useState("");
    const [stage, setStage] = useState("");


    const MAX_SUMMARY_FILE_BYTES = 10 * 1024 * 1024;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiResponse = await AbstractAPI.getAll();
                console.log("Raw API response:", apiResponse);

                // Handle { success: true, data: [...] } structure
                const data = Array.isArray(apiResponse?.data) ? apiResponse.data :
                    Array.isArray(apiResponse) ? apiResponse : [];

                console.log("Processed data length:", data.length);

                const cats = [...new Set(data.map(i => i.category).filter(Boolean))].sort();
                const subcats = [
                    ...new Set(
                        data.map(i => i.sub_category || i.subcategory).filter(Boolean)
                    ),
                ].sort();
                const yrs = [
                    ...new Set(
                        data
                            .map(i => String(i.years || i.Year))
                            .filter(Boolean)
                    ),
                ].sort((a, b) => Number(b) - Number(a));

                console.log("Categories:", cats);
                console.log("Subcategories:", subcats);
                console.log("Years:", yrs);

                setCategories(cats);
                setSubcategories(subcats);
                setYears(yrs);
            } catch (err) {
                console.error("❌ Submit error:", err);

                const errorMsg =
                    err.response?.data?.message ||
                    err.response?.data?.error ||
                    err.message ||
                    "Submission failed. Please try again.";

                setSubmitErrorMessage(errorMsg);
                setSubmitErrorPopup(true);
            }

        };
        fetchData();
    }, []);

    useEffect(() => {
        if (initial) {
            setForm({
                Abstract_Id: String(initial.Abstract_Id || initial.abstract_id || ""),
                Year: String(initial.Year || initial.years || ""),
                title: initial.title || "",
                Status: initial.status || initial.Status || "active",

                author: (initial.author || initial.submitter_first_name || "") +
                    (initial.submitter_last_name ? ` ${initial.submitter_last_name}` : ""),
                category: initial.category || "",
                subcategory: initial.subcategory || initial.sub_category || "",
                abstract: initial.abstract || "",
                summary: initial.summarised_abstract || initial.abstract || initial.summary || "",
                link: initial.link || "",
            });

            const existingCoAuthors = [];
            if (initial.person2_first_name)
                existingCoAuthors.push({ id: 1, name: initial.person2_first_name });
            if (initial.person3_first_name)
                existingCoAuthors.push({ id: 2, name: initial.person3_first_name });
            if (initial.person4_first_name)
                existingCoAuthors.push({ id: 3, name: initial.person4_first_name });
            if (initial.person5_first_name)
                existingCoAuthors.push({ id: 4, name: initial.person5_first_name });

            setCoAuthors(
                existingCoAuthors.length > 0 ? existingCoAuthors : [{ id: 1, name: "" }]
            );
            setFiles(initial.attachments || []);
        } else {
            setForm({
                Abstract_Id: "",
                Year: "",
                title: "",
                Status: "active",
                author: "",
                category: "",
                subcategory: "",
                abstract: "",
                summary: "",
                link: "",
            });
            setCoAuthors([{ id: 1, name: "" }]);
            setFiles([]);
        }
    }, [initial]);

    const extractAbstractFromPDF = async (file) => {
        try {
            const arrayBuffer = await file.arrayBuffer();

            const pdf = await pdfjs.getDocument({
                data: arrayBuffer,
            }).promise;

            let fullText = "";

            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);

                const textContent = await page.getTextContent();

                const pageText = textContent.items
                    .map(item => item.str)
                    .join(" ");

                fullText += pageText + "\n";
            }

            console.log(fullText);
            console.log("FULL PDF TEXT =>", fullText);

            const regex =
                /Abstract[\s\n\r]*:?[\s\n\r]*([\s\S]*?)(?:Index[\s\n\r]*Terms|Keywords|Introduction|$)/i;

            const match = fullText.match(regex);

            console.log("MATCH =>", match);

            const extractedAbstract = match?.[1]?.trim() || "";

            console.log("EXTRACTED ABSTRACT =>", extractedAbstract);

            if (extractedAbstract) {
                setForm(prev => ({
                    ...prev,
                    abstract: extractedAbstract
                }));
            }
            setForm(prev => ({
                ...prev,
                abstract: extractedAbstract
            }));

        } catch (err) {
            console.error("PDF extraction failed:", err);
        }
    };
    const handleAddCoAuthor = () => {
        if (coAuthors.length < 4) {
            const newId = Math.max(...coAuthors.map(a => a.id), 0) + 1;
            setCoAuthors([...coAuthors, { id: newId, name: "" }]);
        }
    };

    const handleRemoveCoAuthor = (id) => {
        if (coAuthors.length > 1) {
            setCoAuthors(coAuthors.filter(author => author.id !== id));
        }
    };

    const handleCoAuthorChange = (id, value) => {
        setCoAuthors(
            coAuthors.map(author =>
                author.id === id ? { ...author, name: value } : author
            )
        );
    };

    const onChange = (e) =>
        setForm(p => ({ ...p, [e.target.name]: e.target.value }));

    const simulateUpload = () => {
        return new Promise((resolve) => {
            setUploading(true);
            setSuccess(false);
            setProgress(0);

            const interval = setInterval(() => {
                setProgress(prev => {
                    const next = prev + 10;
                    if (next >= 100) {
                        clearInterval(interval);
                        setProgress(100);
                        setTimeout(() => {
                            setUploading(false);
                            setSuccess(true);
                            setTimeout(() => {
                                setSuccess(false);
                                resolve();
                            }, 1500);
                        }, 300);
                    }
                    return next;
                });
            }, 200);
        });
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // keep a local copy for UI display
        setFiles(p => [...p, file]);

        // immediately upload the file and save the path returned by the API
        try {
            setFileUploading(true);
            const response = await AbstractAPI.uploadFile(file);

            // the backend should return something like { filepath: "/uploads/abc.pdf" }
            const serverPath =
                response?.filepath || response?.path || response?.filePath || "";

            if (serverPath) {
                setForm(p => ({ ...p, file_path: serverPath }));
            } else {
                console.warn("Upload succeeded but no filepath returned", response);
                // fallback to using the filename so something is sent
                setForm(p => ({ ...p, file_path: file.name }));
            }
        } catch (err) {
            console.error("❌ File upload failed:", err);
            // optionally show an error popup or message to the user
        } finally {
            setFileUploading(false);
        }
    };

    const handleRemoveAttachment = (index) =>
        setFiles(p => p.filter((_, i) => i !== index));

    const handleSummaryFileChange = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;

        if (f.type !== "application/pdf") {
            setSummaryError("Please select a PDF file.");
            return;
        }
        if (f.size > MAX_SUMMARY_FILE_BYTES) {
            setSizeErrorPopup(true);
            return;
        }

        setSummaryFile(f);
        setSummaryError(null);
    };

    // const startSummaryUpload = async () => {
    //     if (!summaryFile) {
    //         setSummaryError("Please select a PDF file.");
    //         return;
    //     }

    //     try {
    //         setSummaryUploading(true);
    //         setSummaryProgress(30);
    //         setSummaryError(null);

    //         // 🔥 Call API
    //         const response = await AbstractAPI.uploadSummaryPDF(summaryFile);

    //         console.log("✅ Summary API Response:", response);

    //         setSummaryProgress(80);

    //         // ✅ Safe extraction
    //         const apiSummary =
    //             response?.content?.summary ||
    //             response?.data?.content?.summary ||
    //             "";

    //         // const apiFilePath =
    //         //     response?.filepath ||
    //         //     response?.data?.filepath ||
    //         //     "";

    //         if (!apiSummary) {
    //             throw new Error("No summary returned from API");
    //         }

    //         // ✅ Save filepath properly
    //         // setSummaryFilePath(apiFilePath || "");

    //         // ✅ Update summary textarea

    //         setForm(prev => ({
    //             ...prev,
    //             summary: apiSummary
    //         }));

    //         setSummaryProgress(100);

    //         setTimeout(() => {
    //             setShowSummaryModal(false);
    //         }, 500);

    //     } catch (error) {
    //         console.error("❌ Summary Upload Failed:", error);
    //         setSummaryError("Failed to process PDF.");
    //     } finally {
    //         setSummaryUploading(false);
    //     }
    // };

    const startSummaryUpload = async () => {
        if (!summaryFile) {
            setSummaryError("Please select a PDF file.");
            return;
        }

        try {
            setSummaryUploading(true);
            setSummaryError(null);
            setSummaryProgress(0);
            setStage("Preparing upload...");

            // ── Stage 1 ── Very beginning
            await new Promise(r => setTimeout(r, 600));
            setSummaryProgress(12);
            setStage("Uploading PDF to server...");

            // ── Stage 2 ── During upload / right after
            await new Promise(r => setTimeout(r, 900)); // pretend upload time
            setSummaryProgress(38);
            setStage("Extracting text from document...");

            await extractAbstractFromPDF(summaryFile);
            // Real API call
            const response = await AbstractAPI.uploadSummaryPDF(summaryFile);

            // ── Stage 3 ── After upload succeeded
            setSummaryProgress(55);
            setStage("Analyzing content with AI...");

            await new Promise(r => setTimeout(r, 1200)); // fake thinking time
            setSummaryProgress(78);
            setStage("Generating concise summary...");

            const apiSummary =
                response?.content?.summary ||
                response?.data?.content?.summary ||
                "";

            if (!apiSummary) {
                throw new Error("No summary returned from API");
            }

            // ── Final stage ──
            setSummaryProgress(94);
            setStage("Finalizing result...");

            setForm(prev => ({ ...prev, summary: apiSummary }));

            // Finish
            await new Promise(r => setTimeout(r, 700));
            setSummaryProgress(100);
            setStage("Complete!");

            setTimeout(() => {
                setShowSummaryModal(false);
                setStage(""); // reset for next time
            }, 900);

        } catch (error) {
            console.error("❌ Summary Upload Failed:", error);
            setSummaryError("Failed to process PDF. Please try again.");
            setSummaryProgress(0);
            setStage("");
        } finally {
            setSummaryUploading(false);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const authorParts = form.author.trim().split(/\s+/);
        const firstName = authorParts[0] || form.author;
        const lastName = authorParts.slice(1).join(" ") || "";
        let finalYear = null;

        if (form.Year && !isNaN(form.Year)) {
            finalYear = Number(form.Year);
        } else if (newYear && !isNaN(newYear)) {
            finalYear = Number(newYear);
        }

        if (!finalYear) {
            alert("Please select a valid year");
            return;
        }

        const payload = {
            abstract_id: form.Abstract_Id
                ? Number(form.Abstract_Id)
                : null,

            years: finalYear,
            updater_id: 0,
            submitter_first_name: firstName,
            submitter_last_name: lastName || "",
            category: form.category,
            sub_category: form.subcategory,
            title: form.title,
            status: form.Status,
            abstract: form.abstract,
            summarised_abstract: form.summary,

            person2_first_name: coAuthors[0]?.name || "",
            person3_first_name: coAuthors[1]?.name || "",
            person4_first_name: coAuthors[2]?.name || "",
            person5_first_name: coAuthors[3]?.name || "",
            // use the path that was stored in form when the file was uploaded
            file_path: form.file_path || files[0]?.name || "",
        };



        try {
            let resData;

            if (initial?.content_id) {

                const updatePayload = {
                    ...payload,
                    content_id: initial.content_id,   // ✅ correct
                };

                delete updatePayload.abstract_id;     // remove during update

                resData = await AbstractAPI.update(updatePayload);
            } else {

                resData = await AbstractAPI.insert(payload);
            }

            console.log("API Response:", resData);

            await simulateUpload();

            setTimeout(() => {
                navigate("/Admin");
            }, 2000);

        } catch (err) {
            console.log(" FULL ERROR OBJECT:", err);

            if (err.response) {
                console.log(" BACKEND RESPONSE:", err.response.data);
                console.log(" STATUS:", err.response.status);
            } else {
                console.log(" NO RESPONSE:", err.message);
            }

            setSubmitErrorPopup(true);
        }
    };

    const handleCancel = () => {
        navigate("/Admin");
    };

    const handleClose = () => {
        navigate("/Admin");
    };

    return (
        <div className="admin-form-container">
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0px"
            }}>


            </div>
            <form onSubmit={handleSubmit} className="admin-form">
                <h2 style={{ margin: 0, justifyContent: "space-between", marginLeft: "12em" }}>{initial ? "Edit Entry" : "New Entry"}
                    <button
                        type="button"
                        onClick={handleClose}
                        style={{
                            border: "none",
                            background: "white",
                            cursor: "pointer",
                            padding: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                            borderRadius: "4px",


                        }}
                    >
                        <CloseIcon fontSize="medium" />
                    </button>
                </h2>

                <div
                    className="form-group"
                    style={{
                        display: "flex",
                        gap: 14,
                        alignItems: "flex-start",
                        flexWrap: "nowrap",
                    }}
                >
                    <div style={{ width: 450, flexShrink: 0 }}>
                        <label className="label label-required">Abstract Id</label>
                        <TextField
                            name="Abstract_Id"
                            value={form.Abstract_Id}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, "");
                                setForm({ ...form, Abstract_Id: value });
                            }}
                            type="text"
                            required
                            fullWidth
                        />
                    </div>

                    <div style={{ width: 450 }}>
                        <label className="label label-required">Year</label>

                        <Autocomplete
                            options={[...years, "Other..."]}
                            value={form.Year || null}
                            onChange={(e, value) => {
                                if (value === "Other...") {
                                    setForm(p => ({ ...p, Year: "other" }));
                                } else {
                                    setForm(p => ({ ...p, Year: value || "" }));
                                    setNewYear("");
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} size="small" required />
                            )}
                        />

                        {form.Year === "other" && (
                            <TextField
                                sx={{ mt: 1 }}
                                type="number"
                                size="small"
                                fullWidth
                                placeholder="Enter year"
                                value={newYear}
                                onChange={(e) => setNewYear(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        const y = newYear.trim();
                                        if (y && !years.includes(y)) {
                                            setYears(prev => [y, ...prev].sort((a, b) => b - a));
                                            setForm(p => ({ ...p, Year: y }));
                                            setNewYear("");
                                        }
                                    }
                                }}

                            />
                        )}
                    </div>
                </div>


                <div className="form-group" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                    <div style={{ width: 450 }}>
                        <label className="label label-required">Category</label>

                        <Autocomplete
                            options={[...categories, "Other..."]}
                            value={form.category || null}
                            onChange={(e, value) => {
                                if (value === "Other...") {
                                    setForm(p => ({ ...p, category: "other" }));
                                } else {
                                    setForm(p => ({ ...p, category: value || "" }));
                                    setNewCategory("");
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} size="small" required />
                            )}
                        />

                        {form.category === "other" && (
                            <TextField
                                sx={{ mt: 1 }}
                                size="small"
                                fullWidth
                                placeholder="Enter category"
                                value={newCategory}
                                onChange={(e) => setNewCategory(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        const c = newCategory.trim();
                                        if (c && !categories.includes(c)) {
                                            setCategories(prev => [...prev, c].sort());
                                            setForm(p => ({ ...p, category: c }));
                                            setNewCategory("");
                                        }
                                    }
                                }}
                            />
                        )}
                    </div>

                    <div style={{ width: 450 }}>
                        <label className="label label-required">Subcategory</label>

                        <Autocomplete
                            options={[...subcategories, "Other..."]}
                            value={form.subcategory || null}
                            onChange={(e, value) => {
                                if (value === "Other...") {
                                    setForm(p => ({ ...p, subcategory: "other" }));
                                } else {
                                    setForm(p => ({ ...p, subcategory: value || "" }));
                                    setNewSubcategory("");
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} size="small" required />
                            )}
                        />

                        {form.subcategory === "other" && (
                            <TextField
                                sx={{ mt: 1 }}
                                size="small"
                                fullWidth
                                placeholder="Enter subcategory"
                                value={newSubcategory}
                                onChange={(e) => setNewSubcategory(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        const s = newSubcategory.trim();
                                        if (s && !subcategories.includes(s)) {
                                            setSubcategories(prev => [...prev, s].sort());
                                            setForm(p => ({ ...p, subcategory: s }));
                                            setNewSubcategory("");
                                        }
                                    }
                                }}
                            />
                        )}
                    </div>

                </div>

                <div className="form-group">
                    <label className="label label-required">Title</label>
                    <TextField
                        name="title"
                        value={form.title}
                        onChange={onChange}
                        placeholder="Abstract Title"
                        size="small"
                        fullWidth
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="label label-required">Author</label>
                    <TextField
                        name="author"
                        value={form.author}
                        onChange={onChange}
                        size="small"
                        fullWidth
                        placeholder="Full name"
                        required
                    />
                </div>

                <div className="form-group">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <label className="label">Co-Authors (Optional)</label>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleAddCoAuthor}
                            disabled={coAuthors.length >= 4}
                        >
                            <AddIcon /> Add Co-Author
                        </button>
                    </div>

                    {coAuthors.map(author => (
                        <div key={author.id} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "center" }}>
                            <TextField
                                value={author.name}
                                onChange={e => handleCoAuthorChange(author.id, e.target.value)}
                                size="small"
                                placeholder={`Co-Author ${coAuthors.indexOf(author) + 1}`}
                                fullWidth
                            />
                            {coAuthors.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => handleRemoveCoAuthor(author.id)}
                                    className="btn btn-danger btn-small"
                                >
                                    <RemoveIcon />
                                </button>
                            )}
                        </div>
                    ))}
                </div>

                <div className="form-group">
                    <label className="label label-required">Status</label>

                    <FormGroup row>

                        {/* ACTIVE */}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={form.Status === "active"}
                                    onChange={(e) =>
                                        setForm(p => ({
                                            ...p,
                                            Status: e.target.checked ? "active" : ""
                                        }))
                                    }
                                />
                            }
                            label="Active"
                        />

                        {/* INACTIVE */}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={form.Status === "inactive"}
                                    onChange={(e) =>
                                        setForm(p => ({
                                            ...p,
                                            Status: e.target.checked ? "inactive" : ""
                                        }))
                                    }
                                />
                            }
                            label="Inactive"
                        />

                    </FormGroup>
                </div>


                <div className="form-group">
                    <label className="label label-required">Content (Abstract)</label>
                    <TextField
                        name="abstract"
                        value={form.abstract}
                        onChange={onChange}
                        multiline
                        minRows={4}
                        placeholder="Enter abstract content..."
                        fullWidth
                        required
                        // contentEditable={false}
                    />
                </div>
                <div className="form-group">
                    <label className="label label-required">Summarized Content</label>
                    <TextField
                        name="summary"
                        value={form.summary}
                        onChange={onChange}
                        multiline
                        minRows={4}
                        placeholder="Summarized content..."
                        fullWidth
                        required
                    />
                </div>


                <div className="form-group">
                    <label className="label">Upload Full Paper (pdf/ppt)</label>
                    <input
                        type="file"
                        accept=".pdf,.ppt,.pptx"
                        onChange={handleFileChange}
                        className="file-input"
                    />
                    {fileUploading && (
                        <div style={{ marginTop: 4, fontSize: 12, color: "#666" }}>
                            Uploading file...
                        </div>
                    )}
                    {files.length > 0 && (
                        <div className="attachments-list">
                            {files.map((f, i) => (
                                <div key={i} className="attachment-item">
                                    <span>
                                        {f.name} • {(f.size / 1024).toFixed(1)} KB
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-small"
                                        onClick={() => handleRemoveAttachment(i)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>


                <div className="form-group">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setShowSummaryModal(true)}
                    >
                        Generate Summary from PDF
                    </button>
                </div>

                <div className="form-actions">
                    <button type="submit" className="btn btn-primary">
                        {initial ? "Update" : "Submit"}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleCancel}
                    >
                        {initial ? "Cancel" : "Reset"}
                    </button>
                </div>

                {/* Upload Progress Popup */}
                <CustomPopup open={uploading || success} onClose={() => { }}>
                    <div className="popup-content-2">
                        {uploading ? (
                            <>
                                <h3 className="popup-title">Processing...</h3>
                                <div className="progress-bar">
                                    <div
                                        className="progress-fill"
                                        style={{ width: `${progress}%` }}
                                    />
                                </div>
                                <p className="progress-text">{progress}%</p>
                            </>
                        ) : success ? (
                            <h3 className="popup-title success-message">
                                ✓ Successfully {initial ? "updated" : "submitted"}!
                            </h3>
                        ) : null}
                    </div>
                </CustomPopup>

                {/* Summary Generation Popup */}
                <CustomPopup open={showSummaryModal} onClose={() => setShowSummaryModal(false)}>
                    <div className="popup-content-">
                        <h3 className="popup-title">Generate Summary from PDF (max 10MB)</h3>

                        <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleSummaryFileChange}
                            className="file-input"
                        />

                        {summaryFile && <p className="file-name">{summaryFile.name}</p>}
                        {summaryError && <p className="error-message">{summaryError}</p>}

                        <div className="popup-actions">
                            <button
                                className="btn btn-primary"
                                onClick={startSummaryUpload}
                                disabled={summaryUploading || !summaryFile}
                            >
                                {summaryUploading ? "Processing..." : "Upload & Generate"}
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowSummaryModal(false)}
                            >
                                Close
                            </button>
                        </div>

                        {summaryUploading && (
                            <div className="progress-container">
                                <AnimatedCircularProgressBar progress={summaryProgress} />
                                <div className="progress-text">{Math.round(summaryProgress)}%</div>

                                {/* ── NEW: stage label ──────────────────────────────── */}
                                {stage && (
                                    <div className="progress-stage">
                                        {stage}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </CustomPopup>

                {/* File Size Error Popup */}
                <CustomPopup open={sizeErrorPopup} onClose={() => setSizeErrorPopup(false)}>
                    <div className="popup-content error">
                        <h4 className="popup-title error-title">File too large</h4>
                        <p className="popup-message">Please select a PDF smaller than 10 MB.</p>
                        <button
                            className="btn btn-primary popup-close-btn"
                            onClick={() => setSizeErrorPopup(false)}
                        >
                            OK
                        </button>
                    </div>
                </CustomPopup>
                {/* Submission Failed Popup */}
                <CustomPopup
                    open={submitErrorPopup}
                    onClose={() => setSubmitErrorPopup(false)}
                >
                    <div className="popup-content error">
                        <h4 className="popup-title error-title">Submission Failed</h4>

                        <p className="popup-message">
                            {submitErrorMessage}
                        </p>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "16px",
                            }}
                        >
                            <button
                                className="btn btn-danger popup-close-btn"
                                onClick={() => setSubmitErrorPopup(false)}
                                style={{
                                    minWidth: "100px",
                                    padding: "8px 20px",
                                    borderRadius: "4px",
                                }}
                            >
                                OK
                            </button>
                        </div>

                    </div>
                </CustomPopup>

            </form>
        </div>
    );
}